module.exports = __webpack_public_path__ + "media/19.66857e7f.mp3";